import React from 'react';

import { AddCircleOutline } from '@material-ui/icons';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { checkPermissions } from '../../services/authorization-service';

export const AddButton = ({ service, history, name }) => {
  const goToAddPage = () => {
    history.push(service.addPage());
  };

  return checkPermissions([`ADD_${name}`]) ? (
    <React.Fragment>
      <Tooltip title="Agregar" placement="top">
        <IconButton onClick={goToAddPage} color="primary">
          <AddCircleOutline />
        </IconButton>
      </Tooltip>
    </React.Fragment>
  ) : (
    ''
  );
};
